import { render, staticRenderFns } from "./bqSelect.vue?vue&type=template&id=471a88b6&scoped=true&"
import script from "./bqSelect.vue?vue&type=script&lang=js&"
export * from "./bqSelect.vue?vue&type=script&lang=js&"
import style0 from "./bqSelect.vue?vue&type=style&index=0&id=471a88b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a88b6",
  null
  
)

export default component.exports